import styled from "styled-components";

const S = {
    Wrapper: styled.div`
        display: flex;
        flex-direction: column;
        padding: 50px 100px;
        margin: 0;
        align-items: center;
        background: #fafafa;
        border-top: 1px solid rgba(0,0,0,0.05);
        border-bottom: 1px solid rgba(0,0,0,0.05);
        
        @media (max-width: 1024px) {
            padding: 40px 20px;
            margin: 0;
        }
    `,
    Header: styled.div`
        margin-bottom: 40px;
        width: 100%;
        max-width: 1400px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        
        .title-wrapper {
            h1 {
                font-size: 3.5em;
                font-weight: 800;
                color: #1a2b34;
                margin: 0;
                letter-spacing: -1px;

                @media (max-width: 768px) {
                    font-size: 2.5em;
                }
            }
        }

        .more-button {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            text-decoration: none;
            background: transparent;
            color: #1a2b34;
            padding: 10px 0;
            font-size: 1.1em;
            font-weight: 600;
            border: none;
            box-shadow: none;
            transition: all 0.3s ease;
            position: relative;

            svg {
                fill: #1a2b34;
                transition: transform 0.3s ease;
            }

            &::after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 0;
                width: 0%;
                height: 2px;
                background: #00A9C4;
                transition: width 0.3s ease;
            }

            &:hover {
                color: #00A9C4;
                background: transparent;
                transform: none;
                box-shadow: none;

                svg {
                    fill: #00A9C4;
                    transform: translateX(6px);
                }

                &::after {
                    width: 100%;
                }
            }
        }
        
        @media (max-width: 768px) {
            flex-direction: column;
            gap: 20px;
            text-align: center;
        }
    `,
    Body: styled.div`
        width: 100%;
        max-width: 1400px;

        .bento-grid {
            display: grid;
            grid-template-columns: 2.5fr 1fr;
            grid-template-rows: repeat(3, 1fr);
            gap: 20px;
            height: 600px;
            
            @media (max-width: 1024px) {
                grid-template-columns: 1fr;
                grid-template-rows: auto;
                height: auto;
            }
        }

        .video-card {
            position: relative;
            background: #000;
            border-radius: 20px;
            overflow: hidden;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
            cursor: pointer;
            transition: transform 0.3s ease, box-shadow 0.3s ease;

            &:hover {
                transform: translateY(-5px);
                box-shadow: 0 15px 35px rgba(0, 169, 196, 0.25);
            }
        }

        .hero-card {
            grid-column: 1 / 2;
            grid-row: 1 / 4;
            
            @media (max-width: 1024px) {
                grid-column: 1 / -1;
                height: 400px;
            }
        }

        .sub-card {
            grid-column: 2 / 3;
            
            @media (max-width: 1024px) {
                grid-column: 1 / -1;
                height: 250px;
            }
        }

        .iframe-wrapper {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                opacity: 0.8;
                transition: opacity 0.5s ease, transform 0.5s ease;
            }

            .gradient-overlay {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 70%;
                background: linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0) 100%);
                pointer-events: none;
                z-index: 1;
            }

            .play-button-overlay {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 64px;
                height: 64px;
                background: rgba(0, 169, 196, 0.85);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: white;
                box-shadow: 0 4px 15px rgba(0, 169, 196, 0.5);
                transition: all 0.3s ease;
                z-index: 2;

                svg {
                    width: 32px;
                    height: 32px;
                    margin-left: 4px;
                }
            }

            .video-title {
                position: absolute;
                bottom: 30px;
                left: 30px;
                right: 30px;
                z-index: 3;

                h3 {
                    margin: 0;
                    color: #fff;
                    font-size: 1.5em;
                    font-weight: 700;
                    line-height: 1.3;
                    text-shadow: 0 2px 10px rgba(0,0,0,0.5);
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }
            }
            
            &:hover img {
                opacity: 1;
                transform: scale(1.05);
            }

            &:hover .play-button-overlay {
                background: #00A9C4;
                transform: translate(-50%, -50%) scale(1.1);
                box-shadow: 0 6px 20px rgba(0, 169, 196, 0.8);
            }
        }
        
        .hero-card .video-title h3 {
            font-size: 2.2em;
            
            @media (max-width: 768px) {
                font-size: 1.5em;
            }
        }
        
        .sub-card .video-title {
            bottom: 20px;
            left: 20px;
            right: 20px;
            
            h3 {
                font-size: 1.1em;
            }
        }
    `,
    ModalOverlay: styled.div`
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.85);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        backdrop-filter: blur(5px);
        animation: fadeIn 0.3s ease;

        @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
        }

        .modal-content {
            position: relative;
            width: 90%;
            max-width: 1000px;
            background: #000;
            border-radius: 16px;
            overflow: hidden;
            box-shadow: 0 0 40px rgba(0, 169, 196, 0.4);
            animation: slideUp 0.4s ease;

            @keyframes slideUp {
                from { transform: translateY(50px); opacity: 0; }
                to { transform: translateY(0); opacity: 1; }
            }
        }

        .close-btn {
            position: absolute;
            top: 15px;
            right: 15px;
            background: rgba(255, 255, 255, 0.2);
            border: none;
            color: white;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            z-index: 10;
            transition: all 0.3s ease;

            &:hover {
                background: #00A9C4;
                transform: rotate(90deg);
            }

            svg {
                width: 24px;
                height: 24px;
            }
        }

        .modal-video-wrapper {
            position: relative;
            padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
            height: 0;
            
            iframe {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
        }
    `
};

export default S;